import React, { useState, useEffect, useRef } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import CartasFinanza from './cartas';
import { formatMoneda, validaSoloNumero, validaMonto, formatoMonto, validarnumberguion } from '../../util/varios';
import moment from 'moment';
import CatalogoPlanCuenta from '../../catalogos/catalogoPlanCuenta';


const TablaCatalogoCuentaContable = () => {
  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  let anio = JSON.parse(sessionStorage.getItem('anioactu'));
  let inputElement = document.getElementById('codigocuenta');

  const accbtncntcontable = JSON.parse(sessionStorage.getItem('accbtncntcontablec'));
  const fechaTope = moment(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());


  const btnCancela = useRef();
  const btnAcepta = useRef();

  const txtId = useRef();
  const txtDescripcion = useRef();
  const cmbTipo = useRef();
  const txtDeducible = useRef();
  const chkPorcen = useRef();
  const chkMilPorcen = useRef();
  const chkUniTri = useRef();
  const chkMontFij = useRef();
  const chkOtroPor = useRef();
  const txtOtroPorcen = useRef();
  const txtIdAgente = useRef();
  const txtCuentaContable = useRef();
  const cmbNaturaleza = useRef();
  const cmbTipoPago = useRef();
  const cmbTipoRecurso = useRef();

  const [operacion, setOperacion] = useState(0);

  const [visibleBtn, setVisibleBtn] = useState('visible')
  const [visibleId, setVisibleId] = useState('visible')
  const [visibleOtro, setVisibleOtro] = useState('collapse')
  const [visibleISLR, setVisibleISLR] = useState('hidden')
  const [tituloHeader, setTituloHeader] = useState('Gestionar Cuentas Contables.')

  const [habilitado, setHabilitado] = useState(true);
  const [catalogoBene, setCatalogoBene] = useState(false);
  const [catalogoCuenta, setCatalogoCuenta] = useState(false);
  const [tercero, setTercero] = useState({
    idagente: '',
    nombre: ''
  }
  )

  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);

  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoBene: true
  });
  const [values, setValues] = useState({
    idplancuenta: '',
    codigocuenta: '',
    descripcion: '',
    idefiscal: '',
    cargable: '',
    naturaleza: '',
    tipopago: '',
    tiporecurso: ''
  });





  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event)
    setValues({ ...values, [inputElement.name]: maskIt('00-000-00-00-000', event.target.value) });
    txtCuentaContable.current.value = maskIt('00-000-00-00-000', event.target.value);

    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57 || event.which >= 96 && event.which <= 105) {



      /* if(cod.length == 2 || cod.length == 6 || cod.length == 9 || cod.length == 12 ){
       
       num = cod.trim() + '-';
       txtCuentaContable.current.value = num;
       
     
     }
     setValues({ ...values, [event.target.name]:num}); */




      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;//alert(e.which);
  };

  const [ciudades, setCiudades] = useState();
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const [operacionPer, setOperacionPer] = useState(0);



  const blanquear = () => {

    txtCuentaContable.current.value = '';
    txtId.current.setAttribute("disabled", true);
    setOperacion(0)
    setTituloHeader('Gestionar Cuentas Contables.');
    setVisibleISLR('hidden')
    setVisibleOtro('collapse')
    setVisibleBtn('visible')
    setVisibleId('visible')

    setValues({
      idplancuenta: '',
      codigocuenta: '',
      descripcion: '',
      idefiscal: '',
      cargable: '',
      naturaleza: '',
      tipopago: '',
      tiporecurso: ''
    })
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoBene: true
    });


    txtId.current.value = '';
    txtDescripcion.current.value = '';

    cmbTipo.current.value = '';

    setActivate(false);
    setHabilitado(true);
    setHabilitadoNU(true);


  }

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/contabilidad/actualizarplancuenta`;

    let body;
    let codig = txtCuentaContable.current.value.trim().replace('-', '')

    body = {
      operacion: ope,
      nid: values.idplancuenta === '' ? 0 : values.idplancuenta,
      codigo: codig,
      descri: values.descripcion.toUpperCase(),
      carga: parseInt(values.cargable) === 0 ? true : false,
      idefi: 0,
      natu: parseInt(values.naturaleza),
      tippago: parseInt(values.tipopago),
      tiprecu: parseInt(values.tiporecurso)
    }

    axios.post(endpoint, body, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (ope === 1) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
        } else if (ope === 2) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
        } else if (ope === 3) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
        }

        blanquear()

        setActivate(false);
      }
    }).catch(function (error) {
      let mensaje = '';
      if (error.response === undefined) {
        mensaje = 'Error de Conexion'
      } else {
        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
          mensaje = 'Ya existe un Registro'

        }
        else {
          mensaje = error.response.data.message
        }
      }
      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
      setActivate(false);
    })
  };


  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
    procesarRegistro();


  };

  const onChange = (event) => {

    if (event.target.name === 'descripcion') {
      event.target.value = event.target.value;
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === 'unidad') {
      if (event.target.value === '4') {
        setVisibleOtro('visible')
      } else {
        setVisibleOtro('collapse')
        txtOtroPorcen.current.value = ''
      }
      setValues({ ...values, [event.target.name]: event.target.value });

    } else if (event.target.name === 'tipo') {
      if (event.target.value === '1') {
        setVisibleISLR('visible')
      } else {
        setVisibleISLR('hidden')
        txtDeducible.current.value = ''
      }
      setValues({ ...values, [event.target.name]: event.target.value });


    }
    else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  }


  const seleccionarRegistroPLanCuenta = (id) => {
    let campos = '*';
    let nomtab = 'plancuenta';
    let nomid = 'idplancuenta';
    /*   let id = txtId.current.value; */
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${parseInt(id)}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {



        if (response.data !== '') {

          txtId.current.value = response.data.idplancuenta;
          txtCuentaContable.current.value = response.data.codigocuenta.substring(0, 2) + '-' + response.data.codigocuenta.substring(2, 5) + '-' + response.data.codigocuenta.substring(5, 7) + '-' + response.data.codigocuenta.substring(7, 9) + '-' + response.data.codigocuenta.substring(9, 12);
          txtDescripcion.current.value = response.data.descripcion.trim();
          cmbTipo.current.value = response.data.cargable ? 0 : 1;
          setValues(response.data)


        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una Cuenta Contable con este Codigo.', icono: 'informacion' });
          txtDescripcion.current.value = '';
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const validarPlancuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {

        seleccionarRegistroPLanCuenta(event.target.value);

      } else {
        setValues({
          idplancuenta: '',
          codigocuenta: '',
          descripcion: '',
          idefiscal: '',
          cargable: '',
          naturaleza: '',
          tipopago: '',
          tiporecurso: ''
        })
        cmbTipo.current.value = '';
        txtCuentaContable.current.value = '';
        txtDescripcion.current.value = '';
      }
    }
  };





  const onCatalogoPlanCuenta = (value) => {
    setCatalogoCuenta(false);
    seleccionarRegistroPLanCuenta(value.idplancuenta)


    if (!botones.modificar) {
      setBotones({ ...botones, catalogoBene: false });
    }
  }

  const onChangeValidar = () => {

    let sigue = true;

    if (!botones.incluir || !botones.modificar) {


          /*   if( !botones.incluir && txtId.current.value === ''){

                setMensaje({ mostrar: true, titulo: 'Notificación', texto:'Debe el Codigo de Registro.', icono: 'informacion' });
                sigue = false;
                txtId.current.focus();

            } else */ if (txtCuentaContable.current.value === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar el Codigo Cuenta Contable.', icono: 'informacion' });
        sigue = false;
        txtCuentaContable.current.focus();

      } else if (txtDescripcion.current.value === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar Una Descripción.', icono: 'informacion' });
        sigue = false;
        txtDescripcion.current.focus();

      } else if (cmbTipo.current.value === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar la Carga.', icono: 'informacion' });
        sigue = false;
        cmbTipo.current.focus();

      } else if (cmbNaturaleza.current.value === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar la Naturaleza.', icono: 'informacion' });
        sigue = false;
        cmbNaturaleza.current.focus();

      } else if (cmbTipoPago.current.value === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar un Tipo de Pago.', icono: 'informacion' });
        sigue = false;
        cmbTipoPago.current.focus();

      } else if (cmbTipoRecurso.current.value === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar un Tipo de Recurso.', icono: 'informacion' });
        sigue = false;
        cmbTipoRecurso.current.focus();

      }




    }
    if (sigue) {

      let msg = '';
      if (!botones.incluir) {
        msg = 'Esta Seguro de Registrar estos Datos.';
      } else if (!botones.modificar) {
        msg = 'Esta Seguro de Modificar estos Datos.';
      } else if (!botones.eliminar) {
        msg = 'Esta Seguro de Eliminar estos Datos.';
      }

      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });


    }
  }

  const onBotones = (op) => (e) => {

    setOperacion(op)
    e.preventDefault();

    if (op === 1) {

      if (accbtncntcontable && accbtncntcontable.toString().substring(0, 1) === '1') {
        setVisibleBtn('hidden');
        setVisibleId('collapse')
        setTituloHeader('Incluir Cuentas Contables.')
        setHabilitado(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          catalogoBene: false
        });
        txtCuentaContable.current.removeAttribute("disabled");
        txtCuentaContable.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 2) {

      if (accbtncntcontable && accbtncntcontable.toString().substring(1, 2) === '1') {
        setTituloHeader('Editar Cuentas Contables.')
        setVisibleBtn('hidden');
        setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoBene: true
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 3) {

      if (accbtncntcontable && accbtncntcontable.toString().substring(3, 4) === '1') {
        setTituloHeader('Eliminar Cuentas Contables.')
        setVisibleBtn('hidden');
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoBene: true
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 4) {

      if (accbtncntcontable && accbtncntcontable.toString().substring(2, 3) === '1') {
        setTituloHeader('Consultar Cuentas Contables.')
        setVisibleBtn('hidden');
        setHabilitado(true);
        txtId.current.focus()
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          catalogoBene: true
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      setVisibleBtn('visible');
      blanquear();
    }
  }

  function numberCharactersPattern(pattern) {
    let numberChars = 0;
    for (let i = 0; i < pattern.length; i++) {
      if (pattern[i] === '0') {
        numberChars++;
      }
    }
    return numberChars;
  }

  function maskIt(pattern, value) {
    let position = 0;
    let currentChar = 0;
    let masked = '';
    while (position < pattern.length && currentChar < value.length) {
      if (pattern[position] === '0') {
        masked += value[currentChar];
        currentChar++;
      } else {
        masked += pattern[position];
      }
      position++;
    }
    return masked;
  }
  function isNumeric(char) {
    return !isNaN(char - parseInt(char));
  }

  let content = '';
  let maxChars = numberCharactersPattern('00-000-00-00-000');

  function applyInputMask(mask) {



    inputElement.addEventListener('keydown', function (e) {
      e.preventDefault();
      if (isNumeric(e.key) && content.length < maxChars) {
        content += e.key;

      }
      if (e.keyCode == 8) {
        if (content.length > 0) {
          content = content.substr(0, content.length - 1);
        }
      }
      setValues({ ...values, [inputElement.name]: maskIt('00-000-00-00-000', content) })
    })
  }

  /*   document.addEventListener('DOMContentLoaded', function() { 
      applyInputMask('00-000-00-00-000');
    }); */


  /*     useEffect(() => {
        seleccionarRegistros()
       
    }, []);
     */

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div className="row col-md-12 py-5" style={{ margin: 0 }}>
        <div className='row col-md-12 py-2' style={{ margin: 0 }}>
          {/*  <div className='col-md-8 mx-auto'>
              <CartasFinanza/>
              </div> */}
          <div className='col-md-7 col-lg-9 py-3 mx-auto card shadow '>

            <div className='col-md-12 row mx-auto  rounded py-2'>
              <div className='col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between'>
                <div className='col-md-6'>

                  <h3>
                    {tituloHeader}
                  </h3>


                </div>
                <div className='col-md-3 d-flex justify-content-end'>

                  <a href='/inicio' className='text-light '><i className="fas fa-times mx-2"></i><span className='fw-bold'>Salir</span></a>

                </div>
              </div>


              <div className='row mx-auto border-azul py-3 rounded' style={{ fontSizeAdjust: '0.6' }}>

                <div className="p-0 col-md-12 " style={{ visibility: visibleId }}>
                  <div className="input-group input-group-sm mb-3 col-xl-2 col-lg-3 col-md-5 col-sm-4" style={{ visibility: visibleId }}>
                    <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO:</label>

                    <input type="text" name='idcuentabancaria' className="form-control fs-6" disabled ref={txtId} defaultValue={values.idplancuenta !== null || values.idplancuenta !== '' ? values.idplancuenta.trim() : ''} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onKeyUp={validarPlancuenta} onBlur={validarPlancuenta} />
                    <button type="button" disabled={botones.catalogo} onClick={() => { setCatalogoCuenta(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>

                  </div>

                </div>


                <div className="input-group input-group-sm col-xl-4 col-lg-5 col-md-8 col-sm-6 mb-3 ">
                  <label className="input-group-text" id="inputGroup-sizing-sm">CUENTA CONTABLE:</label>
                  <input type="text" className="form-control rounded col-md-6 fs-6" ref={txtCuentaContable} disabled={habilitado} id='codigocuenta' name='codigocuenta' maxLength={16} minLength={16}  /* value={values.codigocuenta} */ onKeyUp={handleInputNumChange} onChange={handleInputNumChange}  ></input>
                </div>
                <div className="input-group input-group-sm col-xl-8 col-lg-7  mb-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">DESCRIPCION:</label>
                  <input type="text" className="form-control text-uppercase rounded fs-6" ref={txtDescripcion} disabled={habilitado} name='descripcion' onChange={onChange} ></input>
                </div>
                <div className="input-group input-group-sm mb-3 col-pd-230 px-2">
                  <label className="input-group-text" id="inputGroup-sizing-sm">CARGABLE:</label>
                  <select className="form-select text-uppercase text-center" aria-label="Default select example" name="cargable" ref={cmbTipo} id="cargable" onChange={onChange} disabled={habilitado}>
                    <option value=""> Seleccione</option>
                    <option value="0">Si</option>
                    <option value="1">No</option>


                  </select>
                </div>
                <div className="input-group input-group-sm mb-3 col-pd-340 px-1">

                  <label className="input-group-text" id="inputGroup-sizing-sm">NATURALEZA DE LA CUENTA:</label>
                  <select className="form-select text-uppercase text-center" aria-label="Default select example" value={values.naturaleza} ref={cmbNaturaleza} name="naturaleza" id="naturaleza" onChange={onChange} disabled={habilitado}>
                    <option value=""> Seleccione</option>
                    <option value="1"> Acredora</option>
                    <option value="2">Deudora</option>
                  </select>
                </div>
                <div className="input-group input-group-sm mb-3 col-pd-250 px-1">
                  <label className="input-group-text" id="inputGroup-sizing-sm">TIPO PAGO:</label>
                  <select className="form-select text-uppercase text-center" aria-label="Default select example" name="tipopago" value={values.tipopago} ref={cmbTipoPago} id="tipopago" onChange={onChange} disabled={habilitado}>
                    <option value=""> Seleccione</option>
                    <option value="5"> Orden Compra</option>
                    <option value="7">Pago de Obra</option>
                    <option value="11">Orden Servicio</option>
                    <option value="12">Pago Directo</option>
                    <option value="13">Pago Nomina</option>

                  </select>
                </div>
                <div className="input-group input-group-sm mb-3 col-pd-250 px-1">
                  <label className="input-group-text" id="inputGroup-sizing-sm">TIPO RECURSO:</label>
                  <select className="form-select text-uppercase text-center" aria-label="Default select example" name="tiporecurso" value={values.tiporecurso} ref={cmbTipoRecurso} id="tiporecurso" onChange={onChange} disabled={habilitado}>
                    <option value=""> Seleccione</option>
                    <option value="0"> Normal</option>
                    <option value="1">Ordinario</option>
                    <option value="2">Fides</option>
                    <option value="3">LAE</option>
                    <option value="4">Institución</option>

                  </select>
                </div>

              </div>

              <div className='col-md-12 d-flex justify-content-between mt-2'>
                {visibleBtn === 'visible' ?
                  <div className='col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start'>
                    <button disabled={botones.incluir} onClick={onBotones(1)} className="btn btn-sm mx-1 btn-primary rounded-pill" style={{ height: '27px' }} title='Incluir Plan Cuenta'><i style={{ fontSize: '9px' }} className="fas fa-plus"> Incluir </i> </button>
                    <button disabled={botones.consultar} onClick={onBotones(4)} className="btn btn-sm mx-1 btn-info rounded-pill" style={{ height: '27px' }} title='Consultar Plan Cuenta' ><i style={{ fontSize: '9px' }} className="fas fa-eye">Consultar</i> </button>
                    <button disabled={botones.modificar} onClick={onBotones(2)} className="btn btn-sm mx-1 btn-warning rounded-pill" style={{ height: '27px' }} title='Modificar Plan Cuenta'><i style={{ fontSize: '9px' }} className="fa fa-edit">Modificar</i> </button>
                    <button disabled={botones.eliminar} onClick={onBotones(3)} className="btn btn-sm mx-1 btn-danger rounded-pill" style={{ height: '27px' }} title='Eliminar Plan Cuenta'><i style={{ fontSize: '9px' }} className="fa fa-trash">Eliminar</i> </button>
                  </div> : ''

                }

                <div className='col-md-12 d-flex justify-content-end' style={{ visibility: visibleBtn === 'visible' ? 'collapse' : 'visible' }}>
                  <button disabled={botones.aceptar} onClick={onBotones(5)} ref={btnAcepta} style={{ height: '27px' }} className="mx-2 btn btn-sm rounded-pill btn-success"><i className="fas fa-check-circle" style={{ fontSize: '9px' }}>  Aceptar</i></button>
                  <button disabled={botones.cancelar} onClick={onBotones(6)} ref={btnCancela} style={{ height: '27px' }} className="mx-2 btn btn-danger btn-sm rounded-pill"><i className="fas fa-window-close" style={{ fontSize: '9px' }}> Cancelar</i></button>

                </div>
              </div>
            </div>

          </div>

        </div>
      </div >


      <CatalogoPlanCuenta
        show={catalogoCuenta}
        onHideCancelar={() => { setCatalogoCuenta(false) }}
        onHideAceptaCatalogo={onCatalogoPlanCuenta}
      />


      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
    </div>
  );
}
export default TablaCatalogoCuentaContable;


// WEBPACK FOOTER //
// ./src/components/contabilidad/catalogoCuentasContable.js